export default function puntoPendiente(cards) {
  if (!cards || cards.length === 0) return []
  const puntajes = cards.map((card) => +card.unidades)
  const indiceLider = puntajes?.indexOf(
    puntajes?.reduce((maximo, valor) => (maximo > valor ? maximo : valor)),
  )
  const Fx = (x) => x * (+cards[indiceLider].vneto / +cards[indiceLider].vpercibido)
  return cards.map((card) => Fx(+card.vpercibido))
}
